module.exports = __webpack_public_path__ + "img/default-activity-cover.768df8c4.jpg";